/**
 * A link is external if host does not contain hbs.edu and webdev.int.host.aws.hbsstg.org
 */
export function isExternalLink(href: string): boolean {
  if (!href) {
    return false;
  }

  try {
    const url = new URL(href);

    return (
      !url.host.endsWith("hbs.edu") &&
      !url.host.endsWith("webdev.int.host.aws.hbsstg.org")
    );
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return false;
  }
}

/**
 * Open external http(s) links inside an HTML string in a new tab
 */
export function openExternalLinksInNewTab(html: string): string {
  if (!html || !/<a\b/i.test(html)) return html;

  return html.replace(
    /<a\b((?:[^>"']|"[^"]*"|'[^']*')*)>/gi,
    (match, attributes: string) => {
      const href = /\shref\s*=\s*(?:"([^"]*)"|'([^']*)')/i.exec(attributes);
      const url = href?.[1] ?? href?.[2] ?? "";
      if (!/^https?:\/\//i.test(url) || !isExternalLink(url)) return match;

      const cleaned = attributes
        .replace(/\s+target\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "")
        .replace(/\s+rel\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "");
      return `<a${cleaned} target="_blank" rel="noopener noreferrer">`;
    },
  );
}
